class PeriodSaveController {

    constructor($rootScope, $state, $stateParams, access) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
    }

    $onInit() {
        this.activeTab = this.$stateParams.tab || 'period';
    }
}

PeriodSaveController.$inject = [ '$rootScope', '$state', '$stateParams', 'access' ];

export default PeriodSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/controllers/periods.save.controller.js